// jQuery_T4NT(document).ready(function($) {

//      /**
//      * Variant selection changed
//      */
// 	  $( document ).on( "variant:change", function( evt, variant ) {
// 	    //console.log( variant );
// 	  });
  
// });
// $("li.swatch_pr_item").click(function(){
//   $('.custom-color-info').remove();
// }); 
$("li.bg_css_custom-color").click(function(){
  //$('.custom-color-info').remove();
  //$('#nt_select_ppr_0').append("<b class='custom-color-info' style='color:black;font-size:17px;'>Please write the color you are wanting on the Order Note of the Cart page.</b>");
  alert("Please write the color you are wanting on the Order Note of the Cart page.");
}); 
var original_price=0;
$("input.js_sticky_qty").change(function(){
  if($(this).val()!=''){
    var qty = parseInt($(this).val());
    var sticky_atc_price=$('.sticky_atc_price').text();
    var currency = sticky_atc_price.charAt(0);
    if(original_price==0){
          original_price = parseFloat(sticky_atc_price.substring(1));
    }
    var final_price = original_price * qty;
    final_price=final_price.toFixed(2);
    $('.sticky_atc_price').text(currency+final_price);
  }
}); 
//var action_url="https://prefortune.in/getnewlook/api/";
var action_url="https://tequilaweb.co/";
$("#wholesaler-submit-form").submit(function(e) {
    //prevent Default functionality
    //e.preventDefault();
    
    //get the action-url of the form
    //var actionurl = e.currentTarget.action;

    //do your own request an handle the results
    $.ajax({
            url: action_url+'wholesaler-submit-application.php',
            type: 'post',
            dataType: 'application/json',
            data: $("#wholesaler-submit-form").serialize(),
            beforeSend: function() {
                // setting a timeout
                $('#site_loader').show();
            },
            success: function(data) {
                // alert("Your Application submitted successfully...");
                // console.log(data);
            },
            complete: function() {
                $('#site_loader').hide();
                $('#msg').show();
                document.getElementById('wholesaler-submit-form').reset();
            }
    });
  return false;
});